export default __webpack_public_path__ + "static/media/kobi-aflalo_ma-shehalev-sheli-bahar.d44895ff.mp3";